import { Col, Divider, Modal, Row, Space, Tag, Button } from "antd";
import cx from "classnames";
import styles from "components/elements/Modal/Modal.module.css";
import { DatePicker, Input, RadioGroup, Select } from "components/form";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { HolidaySchema, initialHolidayValues } from "../schemas/holidaySchema";
import dayjs from 'dayjs'
import { CloseOutlined, FilterOutlined, PlusOutlined } from "@ant-design/icons";

const tagRender = (props) => {
    const { label, onClose } = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            closable={false}
            onClose={onClose}
            style={{
                border: "1px solid var(--font, #2BA4DD)",
                borderRadius: "59px",
                marginRight: 3,
                color: "var(--font, #2BA4DD)",
                display: "flex",
                alignItems: "center",
                padding: "4px 8px",
            }}
        >
            {label}
            <CloseOutlined style={{ marginLeft: 4 }} onClick={onClose} />
        </Tag>
    );
};
function formatDate(dateString, pattern = "DD-MM-YYYY") {
    console.log("dateString", dateString);
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format("DD-MM-YYYY");
}

function HolidayModal({
    isModalOpen = false,
    className = "",
    width = 450,
    back = "CANCEL",
    submit = "SAVE",
    onCancel = () => { },
    handleOk = () => { },
    holidayDetails = {},
    holidayTypeOptions,
    calendarList = [],
    handleOnHolidaySubmit = () => { },
    currentCalendar = {}
}) {
    console.log("details ", holidayDetails?.holidayCalendar);
    const { t } = useTranslation()
    return (
        <Modal
            title={holidayDetails?.holidayCalendar?.holidayName ? t("common.edit") : t("common.create")}
            open={isModalOpen}
            maskClosable={false}
            closable={false}
            onOk={handleOk}
            onCancel={() => {
                const cancelBtn = document.getElementById(
                    "year_accumulate_cancelBtn"
                );
                if (cancelBtn) {
                    cancelBtn.click();
                } else {
                    onCancel();
                }
            }}
            className={cx(styles.customStyle, className)}
            width={width}
            footer={null}
            destroyOnClose
        >
            <Formik
                enableReinitialize
                initialValues={{
                    ...initialHolidayValues,
                    ...holidayDetails?.holidayCalendar,
                    holidayCalendarId: holidayDetails?.holidayCalendar?.id,
                    date: dayjs(holidayDetails?.holidayCalendar?.date),
                    holidayType: holidayDetails?.holidayCalendar?.holidayType?.holidayTypeId,
                    holidayCalendarGroupId: holidayDetails?.holidayCalendar?.holidayGroup?.map((o) => o.holidayCalendarGroupId) || []
                }}

                validationSchema={HolidaySchema}
                onSubmit={(values) => {
                    // console.log("values ", values);
                    // const requestBody = {
                    //     ...values,
                    // };
                    handleOnHolidaySubmit(values, onCancel)
                }}

            >
                {({ values = {}, setFiedValue = () => { }, resetForm = () => { }, isValid, dirty }) => {

                    return (
                        <Form>
                            <Space
                                className={styles.container}
                                size={16}
                                direction="vertical"
                            >
                                {/* <Divider /> */}
                                <Row>
                                    <Col span={24}>
                                        <Input
                                            name="holidayName"
                                            placeholder={t("holiday.label.name_th") + t("common.required_field_suffix")}
                                            label={t("holiday.label.name_th")}
                                            size="large"
                                            style={{ width: '100%', height: '43px' }}
                                            required
                                        />

                                    </Col>
                                </Row>

                                <Row>
                                    <Col span={24}>
                                        <Input
                                            name="holidayNameEn"
                                            placeholder={t("holiday.label.name_en") + t("common.required_field_suffix")}
                                            label={t("holiday.label.name_en")}
                                            size="large"
                                            style={{ width: '100%', height: '43px' }}
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>

                                    <Col span={11}>
                                        <Space direction="horizontal">
                                            <DatePicker
                                                format={formatDate()}
                                                placeholder="DD / MM / YYY *"
                                                name="date"
                                                required
                                                label={t("holiday.label.date")}
                                            />
                                        </Space>
                                    </Col>
                                    <Col span={1} />
                                    <Col span={12}>
                                        <Space direction="horizontal">
                                            <RadioGroup
                                                name="holidayType"
                                                label={t("holiday.label.type")}
                                                options={holidayTypeOptions}
                                                required
                                            />
                                        </Space>
                                    </Col>


                                </Row>

                                {/* <Row >
                                    <Col span={1} />
                                    <Col span={10}>
                                        <Input
                                            name="holidayName"
                                            placeholder="Holiday Name (TH) *"
                                            label={t("holiday.label.name_th")}
                                            size="large"
                                            style={{ width: '100%', height: '43px' }}
                                            required
                                        />
                                    </Col>
                                    <Col span={2} />
                                    <Col span={10}>

                                        <Input
                                            name="holidayNameEn"
                                            placeholder="Holiday Name (EN) *"
                                            label={t("holiday.label.name_en")}
                                            size="large"
                                            style={{ width: '100%', height: '43px' }}
                                            required
                                        />
                                    </Col>
                                    <Col span={1} />
                                </Row> */}
                                <Row >

                                    <Col span={24}>
                                        <Select
                                            name="holidayCalendarGroupId"
                                            size="large"
                                            label={
                                                t("holiday.label.activate_in")
                                            }
                                            mode="multiple"
                                            tagRender={tagRender}
                                            options={calendarList?.map((record, index) => {
                                                return {
                                                    // label: i18n.language === "en" ? record?.calendarNameEn : record?.name,
                                                    label: record?.calendarName,
                                                    value: record?.holidayCalendarGroupId
                                                }
                                            })}
                                        />
                                    </Col>

                                </Row>
                                <Row justify={"end"} style={{ gap: 10 }}>
                                    <Button
                                        id="organization__cancelBtn"
                                        key="back"
                                        onClick={() => {
                                            onCancel();
                                            resetForm();
                                        }}
                                        type="default"
                                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "40px", boxShadow: "none" }}
                                    >
                                        {t('action.cancel')}
                                    </Button>
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        disabled={!dirty || !isValid}
                                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "40px", backgroundColor: !dirty || !isValid ? "" : "var(--button-color)", boxShadow: "none" }}
                                    >
                                        {t('action.save')}
                                    </Button>
                                </Row>
                            </Space>
                        </Form>
                    );
                }}
            </Formik>

        </Modal>
    )
}

export default HolidayModal